import { PaginationRequest, PaginationResponse } from '@repo/ui/data-table'

import { Activity } from '../../../lib/types/models/ol/activity/activity'
import { encodeNestedObject } from '../../../lib/utils/functions/misc.functions'
import { API, constructApiUrl } from '../../apis.config'
import { restApiClient } from '../../rest-api-client'

export function getActivities(input: PaginationRequest & { olId: number }) {
  const { olId, ...paginationParams } = input
  return restApiClient
    .url(
      encodeNestedObject<PaginationRequest>(
        constructApiUrl(API.ols.getActivities.url, { olId }),
        paginationParams
      )
    )
    .get<PaginationResponse<Activity>>()
}
